import { render, staticRenderFns } from "./GoodsCombo.vue?vue&type=template&id=38ff45e5&scoped=true"
import script from "./GoodsCombo.vue?vue&type=script&lang=js"
export * from "./GoodsCombo.vue?vue&type=script&lang=js"
import style0 from "./GoodsCombo.vue?vue&type=style&index=0&id=38ff45e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff45e5",
  null
  
)

export default component.exports